import { today, dateFns } from 'constants/index'

export const initialState = {
  adToken: null,
  adAccountId: null,
  date: {
    start: dateFns.startOfWeek(today),
    end: dateFns.endOfDay(today),
  },
  page: {
    current: 0,
    size: 10,
    order: 'asc',
  },
  adsPreview: {
    open: false,
    advertisement: null,
  },
  search: 'campaign',
  campaigns: [],
  ads: [],
  statuses: []
}

function setToken(state, payload) {
  const newState = { ...state }
  if (!payload?.adToken) {
    return state
  }

  newState.adToken = payload.adToken

  return newState
}

function unsetToken(state) {
  const newState = { ...state }

  newState.adToken = null

  return newState
}

function setAccountId(state, payload) {
  const newState = { ...state }
  if (!payload?.adAccountId) {
    return state
  }
  const { adAccountId } = payload

  newState.adAccountId = adAccountId

  return newState
}

function unsetAccountId(state) {
  const newState = { ...state }

  newState.adAccountId = null

  return newState
}

function setDate(state, payload) {
  const newState = { ...state }
  if (!payload?.date) {
    return state
  }
  const { date } = payload

  if (!date?.start || !date?.end) {
    return state
  }

  newState.date = date

  return newState
}

function setCampaigns(state, payload) {
  const newState = { ...state }
  const { campaigns } = payload

  newState.campaigns = campaigns

  return newState
}

function setAds(state, payload) {
  const newState = { ...state }
  const { ads } = payload

  newState.ads = ads

  return newState
}

function setStatuses(state, payload) {
  const newState = { ...state }
  const { statuses } = payload

  newState.statuses = statuses

  return newState
}

export function reducer(state, { type, payload }) {
  switch (type) {
    case 'CONVERSION_REPORT/CLEANUP': {
      return { ...initialState, adAccountsConnected: state.adAccountsConnected }
    }

    case 'CONVERSION_REPORT/TOKEN/SET': {
      return setToken(state, payload)
    }

    case 'CONVERSION_REPORT/TOKEN/UNSET': {
      return unsetToken(state)
    }

    case 'CONVERSION_REPORT/AD_ACCOUNT_ID/SET': {
      return setAccountId(state, payload)
    }

    case 'CONVERSION_REPORT/AD_ACCOUNT_ID/UNSET': {
      return unsetAccountId(state)
    }

    case 'CONVERSION_REPORT/DATE/SET': {
      return setDate(state, payload)
    }

    case 'CONVERSION_REPORT/PAGINATION/SET': {
      return {
        ...state,
        page: {
          ...payload,
        },
      }
    }

    case 'CONVERSION_REPORT/SEARCH/SET': {
      return {
        ...state,
        search: payload.search,
      }
    }

    case 'CONVERSION_REPORT/ADS_PREVIEW/SET': {
      return {
        ...state,
        adsPreview: {
          open: true,
          advertisement: payload.advertisement,
        },
      }
    }

    case 'CONVERSION_REPORT/ADS_PREVIEW/UNSET': {
      return {
        ...state,
        adsPreview: initialState.adsPreview,
      }
    }

    case 'CONVERSION_REPORT/CAMPAIGNS/SET': {
      return setCampaigns(state, payload)
    }

    case 'CONVERSION_REPORT/ADS/SET': {
      return setAds(state, payload)
    }

    case 'CONVERSION_REPORT/STATUSES/SET': {
      return setStatuses(state, payload)
    }

    default:
      throw new Error('Unknown action for conversion report reducer')
  }
}
